import { View } from "@react-pdf/renderer";
import { COLORS } from "../../../../forms/pdf-components/PdfStyles";
import { PdfRow, PdfCol, PdfVerticalDivider } from "../../../../forms/pdf-components/PdfLayout";
import { PdfDataField } from "../../../../forms/pdf-components/PdfDataField";

export const PdfPrescribingPharmacistInfo = ({
  pharmacistName = "",
  pharmacistLicenseNumber = "",
  serviceDate = "",
}) => (
  <View
    style={{
      borderWidth: 1,
      borderColor: COLORS.border,
      backgroundColor: COLORS.bgSection,
    }}
  >
    <PdfRow style={{ padding: 6 }}>
      <PdfCol>
        <PdfDataField label="Pharmacist Name:" value={pharmacistName} />
      </PdfCol>
      <PdfVerticalDivider style={{ marginVertical: 0 }} />
      <PdfCol style={{ paddingLeft: 6 }}>
        <PdfDataField
          label="Pharmacist License Number:"
          value={pharmacistLicenseNumber}
        />
      </PdfCol>
      {!!serviceDate && (
        <>
          <PdfVerticalDivider style={{ marginVertical: 0 }} />
          <PdfCol style={{ paddingLeft: 6 }}>
            <PdfDataField label="Service Date:" value={serviceDate} />
          </PdfCol>
        </>
      )}
    </PdfRow>
  </View>
);
